import { createRouter, createWebHistory } from 'vue-router'
import menuForm from '../components/menuForm.vue'
import treeviewExperimental from '@/components/experimental/treeViewExperimental.vue'
import LoginForm from '@/components/loginForm.vue'

const routes = [
  { path: '/', name: 'loginForm', component: LoginForm }, 
  { path: '/menuForm', name: 'menuForm', component: menuForm },
  { path: '/treeviewExperimental', name: 'treeviewExperimental', component: treeviewExperimental }
  // Puedes agregar más rutas aquí
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router
